import axios from 'axios';
import {useUtilInformation} from '../../../components/hooks/index';
import {lookupSpac} from '../../../constants/url';

async function useLoadLookupSpac() {
  const {token} = useUtilInformation();
  try {
    const response = await axios.get(`${lookupSpac}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default useLoadLookupSpac;
